import api from './index'
import { stringify } from 'qs'
import { axios } from '@/utils/request'

export function login (params) {
  return axios({
    url: api.login,
    method: 'post',
    data: params
  })
}

export function getProjectGroup (id) {
  return axios(`${api.getProjectGroup}/${id}`)
}

export function getProjectGroupConfig (id) {
  return axios(`${api.getProjectGroupConfig}/${id}`)
}

export function listProjectCrane (projectId) {
  return axios(`${api.projectCrane}/${projectId}`)
}

export function getSingleProject (id) {
  return axios(`${api.getSingleProject}/${id}`)
}

export function getConfig (id) {
  return axios(`${api.getConfig}/${id}`)
}

export function getDayStaticData (params) {
  return axios(`${api.getDayStaticData}/${params.nodeId}?${stringify(params)}`)
}

export function getRealData (params) {
  return axios(`${api.getRealData}/${params.nodeId}?${stringify(params)}`)
}

export function getRunData (id) {
  return axios(`${api.getRunData}/${id}`)
}

// 获取报警详情
export function getAlarmDetail (params) {
  return axios(`/api/ListTickets/${params.nodeId}/ticketType/${params.ticketType}/sub/${params.subTicketType}?${stringify(params)}`)
}

export function refreshToken () {
  return axios({
    url: api.refreshToken,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/metric.js